import React from "react";
import { useMediaQuery } from "@mui/material";
import CheckIcon from "/Images/cekidot.svg";
import DeployImage from "/Images/custodyassetsnew3.svg";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import UnderstandingIcon1 from "/Images/understanding1.svg";
import UnderstandingIcon2 from "/Images/understanding2.svg";
import UnderstandingIcon3 from "/Images/understanding3.svg";

const DeploymentSection = () => {
  const isMobile = useMediaQuery("(max-width: 767px)");

  const styles = {
    container: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: "#E7E4E2",
      padding: isMobile ? "50px 20px" : "100px",
      borderRadius: "10px",
    },
    imageContainer: {
      flex: 1,
      display: "flex",
      justifyContent: isMobile ? "center" : "flex-start",
      alignItems: "center",
      marginBottom: isMobile ? "20px" : "0",
    },
    image: {
      width: isMobile ? "80%" : "80%",
      borderRadius: "10px",
    },
    textContainer: {
      paddingRight: isMobile ? "0" : "20px",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start", // Rata kiri pada semua ukuran layar
      textAlign: "left", // Pastikan teks rata kiri pada mobile
    },
    heading: {
      color: "#2D669B",
      fontSize: isMobile ? "20px" : "30px",
      fontWeight: "600",
      marginBottom: isMobile ? "40px" : "30px",
      width: isMobile ? "auto" : "589px",
      textAlign: "left", // Center heading on mobile
    },
    listItem: {
      display: "flex",
      alignItems: "flex-start",
      gap: "10px",
      marginBottom: "20px",
      justifyContent: "flex-start", // Rata kiri semua list item
    },
    listIcon: {
      height: isMobile ? "30px" : "40px",
      marginTop: "4px",
    },
    listTitle: {
      fontWeight: "600",
      fontSize: isMobile ? "0.9rem" : "1rem",
      color: "#214D73",
      marginBottom: "4px",
    },
    listDescription: {
      fontSize: isMobile ? "0.9rem" : "1rem",
      color: "#6D6D6D",
      lineHeight: "1.5",
      margin: 0,
    },
    arrow: {
      marginLeft: "10px",
      backgroundColor: "#2D669B",
      borderRadius: "50%",
      padding: "5px",
      color: "#F4E37B",
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.imageContainer}>
        <img src={DeployImage} alt="Deployment" style={{ maxWidth: 700, width: "80%" }} />
      </div>
      <div style={styles.textContainer}>
        <h2 style={styles.heading}>
          Understanding <br />
          The Deployment Model
        </h2>
        <div style={styles.listItem}>
          <img src={UnderstandingIcon1} alt="On-premise Icon" style={styles.listIcon} />
          <div>
            <span style={styles.listTitle}>On-premise</span>
            <p style={styles.listDescription}>
              Deploy the full Tennet product suite within your infrastructure.
            </p>
          </div>
        </div>
        <div style={styles.listItem}>
          <img src={UnderstandingIcon2} alt="SaaS Icon" style={styles.listIcon} />
          <div>
            <span style={styles.listTitle}>SaaS or Managed</span>
            <p style={styles.listDescription}>
              Leave the full hosting to Tennet while still having the full <br />
              control of your private keys, which Tennet never has access to.
            </p>
          </div>
        </div>
        <div style={styles.listItem}>
          <img src={UnderstandingIcon3} alt="Hybrid Icon" style={styles.listIcon} />
          <div>
            <span style={styles.listTitle}>Hybrid</span>
            <p style={styles.listDescription}>
              Best of both worlds. Keep the most sensitive items with you <br />
              and leave the rest to Tennet.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeploymentSection;
